import { useChatStore } from '../../store/chatStore'; // adjust path if needed

const preSalesChips = [
  'What are our Power BI differentiators?',
  'Compare Salesforce vs HubSpot for mid-market',
  'What ROI metrics can we share for data platform?',
  'How do we position against competitors?',
];

const marketingChips = [
  'Write a campaign headline for Azure DevOps',
  'What data points support our Power BI messaging?',
  'Generate tagline options for our data platform',
  'Key messages for a mid-market campaign',
];

function WelcomeScreen({ onSend, onFocusInput }) {
  const { activeRole } = useChatStore();

  const chips =
    activeRole === 'pre_sales'
      ? preSalesChips
      : marketingChips;

  const subtitle =
    activeRole === 'pre_sales'
      ? 'Sharp, evidence-backed answers for client meetings, proposals and competitive intelligence.'
      : 'Campaign messaging, content frameworks and go-to-market assets grounded in real product data.';

  return (
    <div className="flex-1 flex items-center justify-center px-6" style={{ padding: '2% 0' }}>
      <div className="max-w-xl w-full text-center">
        <h1 className="text-[36px] font-bold text-white mb-4">
          Discover Answers Today
        </h1>

        {/* <p
          className="text-[16px] mb-8"
          style={{ color: 'rgba(255,255,255,0.65)' }}
        >
          {subtitle}
        </p> */}

        {/* Decorative search bar */}
        {/* <div
          className="mx-auto max-w-md mb-8 px-6 py-3 rounded-full cursor-text"
          style={{
            border:
              '1.5px solid rgba(255,255,255,0.30)',
            color:
              'rgba(255,255,255,0.50)',
          }}
          onClick={onFocusInput}
        >
          <span className="text-sm">
            Ask anything about our solutions...
          </span>
        </div> */}

        {/* Chips */}
        <div className="flex flex-wrap justify-center gap-2">
          {chips.map((chip) => (
            <button
              key={chip}
              className="px-4 py-2 rounded-full text-[13px] transition-all"
              style={{
                background:
                  'rgba(255,255,255,0.08)',
                border:
                  '1px solid rgba(255,255,255,0.18)',
                color:
                  'rgba(255,255,255,0.80)',
              }}
              onClick={() => onSend(chip)}
              onMouseEnter={(e) => {
                e.currentTarget.style.background =
                  'rgba(0,200,212,0.15)';
                e.currentTarget.style.borderColor =
                  '#00fac2';
                e.currentTarget.style.color =
                  'white';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background =
                  'rgba(255,255,255,0.08)';
                e.currentTarget.style.borderColor =
                  'rgba(255,255,255,0.18)';
                e.currentTarget.style.color =
                  'rgba(255,255,255,0.80)';
              }}
            >
              {chip}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WelcomeScreen;